export const getFinalOrIndicativeValueFromIndicativeObject = (obj: {
  value?: string;
  indicativeValue?: string;
  minValue?: string;
  maxValue?: string;
}): number | null => {
  let valueAsNumber: number | null = null;
  if (obj?.value) {
    valueAsNumber = Number(obj.value.replace(/%/g, ''));
  } else if (obj?.indicativeValue) {
    valueAsNumber = Number(obj.indicativeValue.replace(/%/g, ''));
  }

  if (valueAsNumber === null || Number.isNaN(valueAsNumber)) {
    return null;
  }

  return valueAsNumber;
};

export const getUnitFromIndicativeObject = (obj: {
  value?: string;
  indicativeValue?: string;
  minValue?: string;
  maxValue?: string;
}): string | null => {
  let unit: string | null = null;
  if (obj?.value?.includes('%')) {
    unit = '%';
  } else if (obj?.indicativeValue?.includes('%')) {
    unit = '%';
  } else if (obj?.minValue?.includes('%')) {
    unit = '%';
  } else if (obj?.maxValue?.includes('%')) {
    unit = '%';
  }

  return unit;
};
